import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter
} from "@/components/ui/alert-dialog";

import { containerVerticalFlowAnalytics } from "../analytics";

export const HardwareSelectionWarning = ({
  showHardwareSelectionWarning,
  onCloseWarning,
  onConfirm
}: {
  showHardwareSelectionWarning: boolean;
  onCloseWarning: () => void;
  onConfirm: () => void;
}) => {
  return (
    <AlertDialog open={showHardwareSelectionWarning} onOpenChange={onCloseWarning}>
      <AlertDialogContent className="w-fit gap-0 border bg-background p-0">
        <AlertDialogDescription className="sr-only">
          Hardware Selection Warning
        </AlertDialogDescription>
        <div className="p-6">
          <div className="subtext-medium leading-6 text-foreground">
            Selected recipe requires more powerful hardware. The required configuration has been
            applied. Please review before continuing.
          </div>
        </div>
        <AlertDialogFooter className="mt-0 flex flex-row !justify-end gap-2 rounded-b-lg border-t border-border px-6 py-4">
          <AlertDialogAction
            onClick={() => {
              containerVerticalFlowAnalytics.trackHardwareWarningAcknowledged();
              onConfirm();
            }}
          >
            Okay
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
